<template>
    <span>
        {{count}}
    </span>
</template>


<script>
// const STORAGE_KEY = "grocery-list";
// const itemsStorage = {
//     fetch: function() {
//         var items = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
//         items.forEach((item,index) => {
//            item.id = index;
//         });
//         itemsStorage.uid = items.length;
//         return items;
//     }
// };

// var filters = {
//     active: function(items) {
//         return items.filter(item => {
//             return !item.completed;
//         })
//     },
// };

import {itemsStorageFunc, itemsStorageFilters} from '@/utils/items-storage';
const STORAGE_KEY = '_aha-coveo-grocery-list';
export default {
    data() {
        return {
            count: itemsStorageFilters.active(itemsStorageFunc.fetch(STORAGE_KEY)).length,
        }
    },
    mounted() {
        this.$eventHub.$on('grocerylist::updated', (data) => {
            this.count = data;
        });
    }
}

</script>



// WEBPACK FOOTER //
// src/app/components/aha-grocery-count.vue